import React from 'react';
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt, FaFacebookF, FaLinkedinIn, FaTwitter } from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="bg-gradient-to-tr from-[#0f2027] via-[#203a43] to-[#2c5364] text-white pt-20 pb-10 px-6 lg:px-20 mt-24 relative z-10">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10">
        {/* Company Info */}
        <div>
          <h3 className="text-2xl font-bold mb-4 text-yellow-400 tracking-tight">MJR Holdings (Pty) Ltd</h3>
          <p className="text-sm text-gray-300 leading-relaxed">
            We are a multidisciplinary leader in the built environment industry, delivering sustainable,
            innovative, and high-impact infrastructure solutions since 2013.
          </p>
        </div>

        {/* Contact Info */}
        <div>
          <h3 className="text-xl font-semibold mb-4 text-yellow-400">Contact</h3>
          <ul className="space-y-3 text-sm text-gray-300">
            <li className="flex items-start gap-3">
              <FaMapMarkerAlt className="text-yellow-300 mt-1" />
              4 Haakdoring Street, West Acres, Mbombela, 1200
            </li>
            <li className="flex items-center gap-3">
              <FaPhoneAlt className="text-yellow-300" />
              068 641 5955 | 071 122 3651 | 060 680 8999
            </li>
            <li className="flex items-center gap-3">
              <FaEnvelope className="text-yellow-300" />
              admin@mjrholdings.co.za
            </li>
          </ul>
        </div>

        {/* Quick Links */}
        <div>
          <h3 className="text-xl font-semibold mb-4 text-yellow-400">Quick Links</h3>
          <ul className="space-y-2 text-sm text-gray-300 mb-6">
            <li><a href="#about" className="hover:text-yellow-400 transition">About Us</a></li>
            <li><a href="#services" className="hover:text-yellow-400 transition">Services</a></li>
            <li><a href="#projects" className="hover:text-yellow-400 transition">Projects</a></li>
            <li><a href="#contact" className="hover:text-yellow-400 transition">Contact</a></li>
          </ul>
        </div>

        {/* Social Media */}
        <div>
          <h3 className="text-xl font-semibold mb-4 text-yellow-400">Follow Us</h3>
          <div className="flex gap-5 text-xl">
            <a href="#" className="hover:text-yellow-300 transition"><FaFacebookF /></a>
            <a href="#" className="hover:text-yellow-300 transition"><FaTwitter /></a>
            <a href="#" className="hover:text-yellow-300 transition"><FaLinkedinIn /></a>
          </div>
        </div>
      </div>

      {/* Bottom Note */}
      <div className="mt-16 border-t border-white/10 pt-6 text-center text-xs text-gray-400">
        <p>© {new Date().getFullYear()} MJR Holdings (Pty) Ltd. All rights reserved.</p>
        <p>
          Designed by{' '}
          <a
            href="https://www.getabyte.co.za"
            target="_blank"
            rel="noopener noreferrer"
            className="text-yellow-300 hover:underline"
          >
            Getabyte
          </a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
